import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgGoKebabVertical({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 17 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.09766 2.5C7.09766 2.89782 7.25569 3.27936 7.537 3.56066C7.8183 3.84196 8.19983 4 8.59766 4C8.99548 4 9.37701 3.84196 9.65832 3.56066C9.93962 3.27936 10.0977 2.89782 10.0977 2.5C10.0977 2.10218 9.93962 1.72064 9.65832 1.43934C9.37701 1.15804 8.99548 1 8.59766 1C8.19983 1 7.8183 1.15804 7.537 1.43934C7.25569 1.72064 7.09766 2.10218 7.09766 2.5ZM7.09766 7.5C7.09766 7.89782 7.25569 8.27936 7.537 8.56066C7.8183 8.84196 8.19983 9 8.59766 9C8.99548 9 9.37701 8.84196 9.65832 8.56066C9.93962 8.27936 10.0977 7.89782 10.0977 7.5C10.0977 7.10218 9.93962 6.72064 9.65832 6.43934C9.37701 6.15804 8.99548 6 8.59766 6C8.19983 6 7.8183 6.15804 7.537 6.43934C7.25569 6.72064 7.09766 7.10218 7.09766 7.5ZM8.59766 14C8.40067 14 8.20562 13.9612 8.02363 13.8858C7.84164 13.8104 7.67628 13.6999 7.537 13.5607C7.39771 13.4214 7.28722 13.256 7.21184 13.074C7.13645 12.892 7.09766 12.697 7.09766 12.5C7.09766 12.303 7.13645 12.108 7.21184 11.926C7.28722 11.744 7.39771 11.5786 7.537 11.4393C7.67628 11.3001 7.84164 11.1896 8.02363 11.1142C8.20562 11.0388 8.40067 11 8.59766 11C8.99548 11 9.37701 11.158 9.65832 11.4393C9.93962 11.7206 10.0977 12.1022 10.0977 12.5C10.0977 12.8978 9.93962 13.2794 9.65832 13.5607C9.37701 13.842 8.99548 14 8.59766 14Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgGoKebabVertical;
